<template>
  <div :class="$style.search">
    <form :class="$style.searchForm" @submit.prevent="handleSearch">
      <input
        ref="search"
        v-model="searchValue"
        type="text"
        :placeholder="localizedStrings['enterSearch']"
        :class="$style.searchField"
      />
      <button type="submit" :class="$style.submit">
        <i :class="$style.utilsIcon">
          <IconMagnifyingGlass :class="$style.searchIcon" />
        </i>
      </button>
    </form>
  </div>
</template>

<script setup lang="ts">
const { localizedStrings } = useLocalizedStrings()
const localePath = useLocalePath()
const searchValue = defineModel<string>('')

const handleSearch = () => {
  if (searchValue.value && searchValue.value.length) {
    navigateTo({
      path: localePath('/search'),
      query: {
        q: searchValue.value,
      },
    })
  }
}
</script>

<style lang="scss" module>
.search {
  background: #fff;
  padding: 12px 14px;
}

.searchIcon {
  color: var(--purple);
  fill: currentColor;
}

.searchForm {
  display: flex;
  align-items: center;
  border: 1px solid var(--gray-2);

  &:focus-within {
    border: 1px solid var(--purple-light);
  }
}

.searchField {
  height: 47px;
  line-height: 47px;
  padding: 0 13px;
  border: 0;
  flex: 1 1 100%;

  &:focus {
    outline: 0;
  }
}

.submit {
  display: block;
  border: 0;
  background: none;
  width: 45px;
  height: 45px;
}
</style>
